var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#219EBC",
    fillOpacity: 0.14
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11517_56654)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3359 8.66927H12.6693V10.0026H11.3359V8.66927ZM11.3359 11.3359H12.6693V15.3359H11.3359V11.3359ZM12.0026 5.33594C8.3226 5.33594 5.33594 8.3226 5.33594 12.0026C5.33594 15.6826 8.3226 18.6693 12.0026 18.6693C15.6826 18.6693 18.6693 15.6826 18.6693 12.0026C18.6693 8.3226 15.6826 5.33594 12.0026 5.33594ZM12.0026 17.3359C9.0626 17.3359 6.66927 14.9426 6.66927 12.0026C6.66927 9.0626 9.0626 6.66927 12.0026 6.66927C14.9426 6.66927 17.3359 9.0626 17.3359 12.0026C17.3359 14.9426 14.9426 17.3359 12.0026 17.3359Z",
    fill: "#219EBC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11517_56654"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.dbfe9e8e0ecee050b80af08367626317.svg";
export { ForwardRef as ReactComponent };